<template>
    <div>
        <h5 class="header-text">Anti platelet (複選)</h5>
        <template v-for="(n, index) in getList.length">
            <v-layout v-if="(index%2)==0" :key="n">
                <v-checkbox class="flex xs6 pl-0" 
                    :key="getList[index].value"
                    :label="getList[index].text"
                    :value="getList[index].value"
                    v-model="selected"
                    @change="selectOne(getList[index].value)"
                    hide-details
                ></v-checkbox>
                <v-checkbox class="flex xs6 pl-0" v-if="getList[index+1]"
                    :key="getList[index+1].value"
                    :label="getList[index+1].text"
                    :value="getList[index+1].value"
                    v-model="selected"
                    @change="selectOne(getList[index+1].value)"
                    hide-details
                ></v-checkbox>
            </v-layout>
        </template>
        <v-layout class="others full-width">
            <v-checkbox class="pl-0"
                label="其他"
                v-model="othersSelected"
                hide-details
            ></v-checkbox>
            <v-text-field 
                :value="data.antiplateletOther"
                @change="selectOther($event)"
                hide-details
            ></v-text-field>
        </v-layout>
        <div class="antiplatelet-stopdays">
            <p>抗凝血藥物停藥天數</p>
            <v-text-field 
                type="number"
                width="30px"
                :value="data.antiplateletStopDays"
                min=0
                @change="$emit('change', { field: 'antiplateletStopDays', event: $event })"
                hide-details
            ></v-text-field>
            <p>天 </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AntiplateletInput',

  props: {
    data: {
      type: Object,
      required: true
    },
  },

  data () {
    return {
      selected: this.data.antiplateletIDs,
       othersSelected: false
    }
  },

  computed: {
    ...mapGetters('examinations', [
      'getAntiplateletList'
    ]),

    getList () {
      return this.getAntiplateletList.map(item => {
        return {
          text: item.antiplatelet,
          value: item.id
        }
      })
    }
  },
  methods: {
    selectOne(value) {
      this.$emit('change', { field: 'antiplateletID', event: this.selected.join(",") })
    },
    selectOther(value) {
      this.$emit('change', { field: 'antiplateletOther', event: value })
      this.othersSelected = (value && value.length > 0)
    }
  },
  mounted() {
    this.othersSelected = (this.data.antiplateletOther && this.data.antiplateletOther.length > 0)
  }
}
</script>